import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const guides = {
    "uk-essentials-for-indians": { title: "UK Essentials Checklist", blurb: "What to pack and buy when you move" },
    "first-week-in-uk-checklist": { title: "First Week in the UK", blurb: "Bank, NI number, GP, SIM and travel" },
    "indian-areas-in-london": { title: "Best Areas for Indians in London", blurb: "Community, food, rent and transport" },
    "airport-cabs": { title: "Airport Cabs", blurb: "Fixed-fare transfers from Heathrow & Gatwick" },
    "money-transfer-to-india": { title: "Send Money to India", blurb: "Better GBP to INR rates than banks" },
    "top-london-attractions": { title: "Top London Attractions", blurb: "50 places to visit, many free" },
    "uk-jobs-for-indians": { title: "UK Jobs for Indians", blurb: "Visas, job boards and sponsored roles" },
    "cv-and-interview-help": { title: "CV & Interview Help", blurb: "Turn your resume into a UK CV" },
    "it-courses-and-certifications": { title: "IT Courses", blurb: "DevOps, AWS, QA and AI training" },
    "visa-and-immigration-support": { title: "Visa & Immigration", blurb: "Student, Graduate and Skilled Worker visas" },
    "student-admissions-uk": { title: "Study in the UK", blurb: "Universities, UCAS and applications" },
    "mortgages-for-indians": { title: "Mortgages for Indians", blurb: "Buying a home on a UK visa" },
    "uk-tour-trips": { title: "UK Tour Trips", blurb: "Coach trips and day tours from London" },
    "indian-events-and-festivals": { title: "Indian Festivals in the UK", blurb: "Diwali, Navratri and more" },
};

// Hand-picked so each page links to what its readers need next
const related = {
    "uk-essentials-for-indians": ["first-week-in-uk-checklist", "indian-areas-in-london", "airport-cabs", "money-transfer-to-india"],
    "first-week-in-uk-checklist": ["uk-essentials-for-indians", "airport-cabs", "money-transfer-to-india", "visa-and-immigration-support"],
    "indian-areas-in-london": ["uk-essentials-for-indians", "airport-cabs", "indian-events-and-festivals", "top-london-attractions"],
    "airport-cabs": ["first-week-in-uk-checklist", "uk-essentials-for-indians", "indian-areas-in-london", "money-transfer-to-india"],
    "money-transfer-to-india": ["mortgages-for-indians", "uk-essentials-for-indians", "uk-jobs-for-indians", "visa-and-immigration-support"],
    "top-london-attractions": ["uk-tour-trips", "indian-events-and-festivals", "indian-areas-in-london", "uk-essentials-for-indians"],
    "uk-jobs-for-indians": ["cv-and-interview-help", "it-courses-and-certifications", "visa-and-immigration-support", "indian-areas-in-london"],
    "cv-and-interview-help": ["uk-jobs-for-indians", "it-courses-and-certifications", "visa-and-immigration-support", "student-admissions-uk"],
    "it-courses-and-certifications": ["uk-jobs-for-indians", "cv-and-interview-help", "visa-and-immigration-support", "student-admissions-uk"],
    "visa-and-immigration-support": ["uk-jobs-for-indians", "student-admissions-uk", "first-week-in-uk-checklist", "mortgages-for-indians"],
    "student-admissions-uk": ["visa-and-immigration-support", "first-week-in-uk-checklist", "uk-essentials-for-indians", "indian-areas-in-london"],
    "mortgages-for-indians": ["visa-and-immigration-support", "money-transfer-to-india", "indian-areas-in-london", "uk-jobs-for-indians"],
    "uk-tour-trips": ["top-london-attractions", "indian-events-and-festivals", "airport-cabs", "indian-areas-in-london"],
    "indian-events-and-festivals": ["uk-tour-trips", "top-london-attractions", "indian-areas-in-london", "uk-essentials-for-indians"],
    "partner-with-us": ["airport-cabs", "uk-tour-trips", "indian-events-and-festivals", "money-transfer-to-india"],
};

function RelatedGuides() {
    const { pathname } = useLocation();
    const slug = pathname.replace(/^\/+|\/+$/g, '');
    const picks = related[slug];
    if (!picks) return null;

    return (
        <section aria-labelledby="related-guides" className="container mx-auto px-4 mb-8">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
                <h2 id="related-guides" className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-4">Related guides</h2>
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                    {picks.map((p) => (
                        <li key={p}>
                            <Link to={`/${p}`} className="block h-full p-4 rounded-lg bg-gray-50 dark:bg-gray-900 hover:bg-indigo-50 dark:hover:bg-gray-700 transition-colors">
                                <span className="block font-semibold text-indigo-700 dark:text-indigo-300">{guides[p].title}</span>
                                <span className="block text-sm text-gray-600 dark:text-gray-400 mt-1">{guides[p].blurb}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
                <p className="mt-4 text-sm">
                    <Link to="/" className="text-indigo-600 dark:text-indigo-400 hover:underline">Looking for a room or flatmate? Browse listings →</Link>
                </p>
            </div>
        </section>
    );
}

export default RelatedGuides;
